import { PageShell } from "../../components/service/PageShell";
import { ServiceHero, CtaPrimary, CtaGhost, StepsList, FaqBlock, Section, Overline, SectionTitle, Accent, Reveal } from "../../components/service/Blocks";
import { LeadForm } from "../../components/LeadForm";
import { waLink } from "../../data/site";
import { BatteryCharging, Gauge, Zap } from "lucide-react";

const WA_MSG = "Vim pelo site. Quero saber dos eletropostos iGreen Mob.";
const MOB_URL = "https://igreenmob.com.br/?ref=55b7a585-8cb3-41ce-bdb5-3bdb69ce4fc7";

const FAQ = [
  { q: "Qual a diferença entre 7, 40 e 80 kW?", a: "É a potência do carregador: quanto maior, mais rápida a recarga, respeitando o limite que o seu carro aceita." },
  { q: "Onde ficam os eletropostos?", a: "A lista de locais está sendo divulgada. Me chame no WhatsApp para saber dos mais próximos de você." },
];

export default function Mob() {
  return (
    <PageShell testid="page-mob">
      <ServiceHero
        testid="mob-hero"
        overline="iGreen Mob · mobilidade elétrica"
        title={["Recarga para carro elétrico", "num só app."]}
        sub="Eletropostos de 7, 40 e 80 kW e um aplicativo para localizar, iniciar e acompanhar a recarga. Uma novidade da iGreen."
        bullets={["7, 40 e 80 kW", "App de recarga", "Novidade"]}
        primary={<CtaPrimary href={MOB_URL} testid="mob-know-cta">Conhecer o iGreen Mob</CtaPrimary>}
        secondary={<CtaGhost href={waLink(WA_MSG)} testid="mob-whatsapp-cta">Falar no WhatsApp</CtaGhost>}
      />

      <Section className="bg-[#061A14]" testid="mob-powers">
        <div className="grid sm:grid-cols-3 gap-5">
          {[
            { icon: Zap, kw: "7 kW", text: "Recarga semirrápida para o dia a dia: condomínios, estacionamentos e comércios." },
            { icon: BatteryCharging, kw: "40 kW", text: "Recarga rápida para quem está na estrada ou tem pouco tempo." },
            { icon: Gauge, kw: "80 kW", text: "Recarga ultrarrápida: em poucos minutos você segue viagem." },
          ].map((p, i) => (
            <Reveal key={p.kw} delay={i * 0.1}>
              <div className="rounded-2xl border border-[#00E676]/20 bg-[#0B261E]/70 p-8 text-center h-full transition-[border-color,transform] duration-300 hover:border-[#00E676]/50 hover:-translate-y-1">
                <p.icon size={28} className="mx-auto text-[#00E676]" />
                <p className="mt-4 font-heading text-3xl font-extrabold text-white">{p.kw}</p>
                <p className="mt-2 text-xs text-emerald-100/55 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <Section testid="mob-o-que-e">
        <Reveal>
          <Overline>O que é</Overline>
          <SectionTitle>O que já se <Accent>sabe</Accent></SectionTitle>
          <p className="mt-5 max-w-2xl text-sm sm:text-base text-emerald-100/60 leading-relaxed">
            O iGreen Mob reúne eletropostos e recargas num único ecossistema, com app para localizar o ponto, iniciar a
            recarga e acompanhar tudo pelo celular.
          </p>
          <p className="mt-4 max-w-2xl text-sm sm:text-base text-emerald-100/60 leading-relaxed">
            Locais, preços e formas de uso estão sendo divulgados aos poucos. Me chame no WhatsApp que eu te passo as informações mais recentes.
          </p>
        </Reveal>
        <div className="mt-12 grid lg:grid-cols-2 gap-12 items-start">
          <Reveal>
            <Overline>Passo a passo</Overline>
            <SectionTitle>Como vai <Accent>funcionar</Accent></SectionTitle>
          </Reveal>
          <StepsList
            testid="mob-steps"
            steps={[
              { n: "01", title: "Encontre um eletroposto", text: "Pelo app, veja os pontos de recarga." },
              { n: "02", title: "Inicie a recarga", text: "Comece a recarga pelo celular." },
              { n: "03", title: "Acompanhe", text: "Veja o andamento da recarga em tempo real." },
              { n: "04", title: "Siga viagem", text: "Recarregou, é só sair." },
            ]}
          />
        </div>
      </Section>

      <FaqBlock testid="mob-faq" title={<>Perguntas sobre <Accent>iGreen Mob</Accent></>} items={FAQ} />

      <LeadForm
        overline="Vamos conversar?"
        title={<>Me conta o seu caso e eu te respondo <Accent>no WhatsApp</Accent>.</>}
        defaultInterest="Eletroposto (iGreen Mob)"
      />
    </PageShell>
  );
}
